<!-- <div [class.full-width]="inverse"> -->
<div class="grid">
  <ng-content></ng-content>
</div>

